import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { useLeadershipGroups } from '@/hooks/use-leadership-groups';
import { cn } from '@/utils/cn';

const STATIC_LINKS = [
  { to: '/people/leadership/council', end: false, key: 'nav.council' },
  { to: '/people/leadership/ministers', end: false, key: 'nav.ministers' },
] as const;

export const LeadershipSubnav = () => {
  const { t } = useTranslation('people');
  const groups = useLeadershipGroups();

  return (
    <nav className="mb-6 flex flex-wrap gap-2" aria-label={t('nav.leadership')}>
      {STATIC_LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive ? 'bg-brand/10 text-brand' : 'text-fg-secondary hover:bg-surface-sunken',
            )
          }
        >
          {t(link.key)}
        </NavLink>
      ))}
      {(groups.data ?? []).map((group) => (
        <NavLink
          key={group.id}
          to={`/people/leadership/groups/${group.id}`}
          end
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive ? 'bg-brand/10 text-brand' : 'text-fg-secondary hover:bg-surface-sunken',
            )
          }
        >
          {group.name}
        </NavLink>
      ))}
    </nav>
  );
};
